import { getСartTotal, renderCart, renderCartMessage } from './cart.js';
import { showOrederBlockMessage, showOrederBlockLink } from './order-block.js';
import {store} from './store.js';

const updateCatalogItemStatus = () => {
  document.querySelectorAll('.catalog-button').forEach((button) => {
    const isInCart = store.some(item => item.id === button.dataset.itemId);
    button.disabled = isInCart;
    const buttonText = button.dataset.itemButtonText;
    button.querySelector('.catalog-button__text').textContent = isInCart ? 'В корзине' : buttonText;
  });
};

const handleSaveItem = (item) => {
  return () => {
    store.push(item);
    localStorage.setItem('sd-catalog-cart', JSON.stringify(store));

    updateCatalogItemStatus(store);
    getСartTotal(store);
    renderCart(store);
    renderCartMessage(store);
    showOrederBlockMessage(store);
    showOrederBlockLink(store);

    console.log(store);
  };
};

const saveCatalogItems = () => {
  document.querySelectorAll('.catalog-button').forEach((button) => {
    const newItem = {
      id: button.dataset.itemId,
      title: button.dataset.itemTitle,
      price: button.dataset.itemPrice,
    };

    // Удаляем предыдущий обработчик, если он есть
    if (button._clickHandler) {
      button.removeEventListener('click', button._clickHandler);
    }

    // Создаем новый обработчик и сохраняем ссылку на него
    button._clickHandler = handleSaveItem(newItem);
    button.addEventListener('click', button._clickHandler);
  });
};

export { 
  updateCatalogItemStatus, 
  saveCatalogItems, 
};